<div
  [ngClass]="{ 'deleted-document': document.UI_isDeleted }"
  class="document-card"
>
  <div fxLayout="row" fxLayoutGap="8px">
    <img alt="receipt" src="/assets/icons/receipt.svg" />
    <div class="document-card-content">
      <div class="file-name">{{ document.fileName }}</div>
      <div class="file-size">{{ document.fileSize }}</div>
    </div>
  </div>

  <div fxLayout="row" fxLayoutAlign="center" fxLayoutGap="8px">
    <button
      (click)="onView()"
      *ngIf="showViewButton"
      class="document-card-close"
      mat-button
    >
      <mat-icon>visibility</mat-icon>
    </button>

    <button
      (click)="onToggleDelete()"
      *ngIf="showDeleteButton"
      class="document-card-close"
      mat-button
    >
      <mat-icon>{{ document.UI_isDeleted ? "undo" : "close" }}</mat-icon>
    </button>
  </div>
</div>
